import {gql, useQuery} from "@apollo/client";
import {DSP_FIELDS, DspType} from "../types/DspType";
import { useEffect, useState } from "react";

export const GET_DSPS_BY_HUB_ID = gql`
  query GetDspsByHubId($hubId: Long!) {
    dspList: getDspsByHubId(hubId: $hubId) {
      ...DspFields
    }
  }
  ${DSP_FIELDS}
`;

export interface GetDspsByHubIdResponse {
    dspList: DspType[];
}

export interface GetDspsByHubIdVariables {
    hubId: number;
}

export const useDspsByHubId = (hubId?: number) => {
    const [dsps, setDsps] = useState<DspType[]>([]);
    const {data, loading, error, refetch} = useQuery<GetDspsByHubIdResponse, GetDspsByHubIdVariables>(
        GET_DSPS_BY_HUB_ID,
        {
            variables: { hubId: hubId! },
            skip: !hubId, // 当没有 hubId 时跳过查询
        }
    );
    
    useEffect(() => {
        if (data) {
           setDsps(data.dspList.map(dsp => ({...dsp, warehouseIds: dsp.warehouses.map(warehouse => Number(warehouse.id))})));
      }
    }, [data]);

  return {
    dsps,
    loading,
    refetch,
    error
  };
};

